module.exports = __webpack_public_path__ + "img/Dantam Hair 21.4793d863.jpg";